var map = {
	"./balance.svg": "d727",
	"./chair.svg": "adff",
	"./envelope.svg": "ad8b",
	"./fax.svg": "ba1f",
	"./gallery.svg": "86f5",
	"./handwerk-logo.svg": "1317",
	"./home.svg": "68cb",
	"./idea.svg": "63c7",
	"./interior.svg": "e331",
	"./logo.svg": "ce80",
	"./menu.svg": "a7ae",
	"./outdoor.svg": "1303",
	"./partners.svg": "876f",
	"./phone-call.svg": "8dfa",
	"./rating_empty.svg": "46e9",
	"./rating_full.svg": "7508",
	"./rating_half.svg": "87f5",
	"./sketch.svg": "466d",
	"./tags.svg": "0a87",
	"./team.svg": "fc3f",
	"./window.svg": "3dee"
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
}
function webpackAsyncContextResolve(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var id = map[req];
		if(!(id + 1)) { // check for number or string
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return id;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = "cba1";
module.exports = webpackAsyncContext;